import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MediaDeleteConfirmDialogData {
  fileName: string;
  usedInTemplates: string[];
}

@Component({
    selector: 'app-media-delete-confirm-dialog',
    templateUrl: './media-delete-confirm-dialog.component.html',
    standalone: false
})
export class MediaDeleteConfirmDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<MediaDeleteConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MediaDeleteConfirmDialogData
  ) {
    dialogRef.disableClose = true;
  }
}
